import type { FilterConditionDTO } from "@/shared/contracts/base";
import type { ExpenseSummaryStatusFilter } from "../ui/ExpenseSummaryCards";

export const EXPENSES_OVERVIEW_PATH = "/app/expenses/overview";

export function expenseRecordsSearchWithStatus(
  status: ExpenseSummaryStatusFilter,
): {
  limit: number;
  offset: number;
  filters?: FilterConditionDTO[];
} {
  if (status === "all") {
    return { limit: 20, offset: 0 };
  }

  const filters: FilterConditionDTO[] = [
    { field: "status", op: "eq", value: status },
  ];

  return { limit: 20, offset: 0, filters };
}
